<template>
  <div v-if="!$vuetify.display.mobile" class="parent d-flex flex-row ml-md-16 mr-md-16 mr-0 ml-4 mb-6">
    <div class="compare-data legend pa-4 pl-0 div1">

      <div class="compare-header checkbox-wrapper d-flex align-center">
        <label class="container input-label text-left pr-2 mb-6 mb-md-0">
          {{$t('donor.compare.show_only_differences_label')}}
          <input type="checkbox" v-model="differencesChecked">
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="description-header d-flex align-center">
        <img :src="group_icon" class="mr-2"/><span>{{$t('donor.phenotype.origin_label')}}</span>
      </div>
      <div class="description" v-if="isNotEqual('race')">{{$t('donor.phenotype.race')}}</div>
      <div class="description" v-if="isNotEqual('skin_color')">{{$t('donor.phenotype.skin_color')}}</div>

      <div class="description-header d-flex align-center mt-16">
        <img :src="blood_icon" class="mr-2"/><span>{{$t('donor.phenotype.blood_label')}}</span>
      </div>
      <div class="description" v-if="isNotEqual('blood_type')">{{$t('donor.phenotype.blood_type')}}</div>
      <div class="description" v-if="isNotEqual('blood_rh_factor')">{{$t('donor.phenotype.blood_fh_factor')}}</div>

      <div class="description-header d-flex align-center mt-16">
        <img :src="eye_icon" class="mr-2"/><span>{{$t('donor.phenotype.physical_features_label')}}</span>
      </div>
      <div class="description" v-if="isNotEqual('eye_color')">{{$t('donor.phenotype.eye_color')}}</div>
      <div class="description high" v-if="isNotEqual('hair_color')">{{$t('donor.phenotype.hair_color')}}</div>
      <div class="description" v-if="isNotEqual('hair_structure')">{{$t('donor.phenotype.hair_shape')}}</div>
      <div class="description" v-if="isNotEqual('height')">{{$t('donor.phenotype.height')}}</div>
      <div class="description high" v-if="isNotEqual('silhouette')">{{$t('donor.phenotype.body_type')}}</div>

    </div>

    <div class="compare-data donor pa-4 div2" v-if="Object.keys(compareTable.donor).length">
      <div class="compare-header">
        <div class="photo-wrapper d-flex flex-column justify-start w-100">
          <img :src="placeholder" class="photo mb-2" />
          <span>{{getDonorGender}}</span>
          <div class="id-wrapper d-flex align-items-center mt-3" v-if="donor_nickname">
            <span class="pr-2" v-if="oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')">
              {{$t('donor.compare.nickaname_label')}} 
            </span>
            <span class="id px-3">{{donor_nickname}}</span>
            <v-icon v-if="oidc_user?.roles.includes('ROLE_PATIENT')"
              @click="toggleFavourite" :icon="isFavourite ? 'mdi-heart' : 'mdi-heart-outline'" 
              :size="24" class="icon ml-2" :color="isFavourite ? 'primary' : 'primary200'"></v-icon>
          </div>
        </div>
        <div class="id-wrapper d-flex align-items-center" v-if="oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')">
          {{$t('donor.compare.profile_id_label')}} <span class="id px-3 ml-1">{{donor_id}}</span>
        </div>
        <div class="id-wrapper d-flex align-items-center" data-test="donor-age-compare-data-item"
          v-if="oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR') && donor_phenotype.age">
          {{$t('donor.phenotype.age')}}
          <span class="id px-3 ml-1">{{donor_phenotype.age}}</span>
        </div>
      </div>

      <div class="description-header d-flex align-center"></div>
      <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('race')">
        {{$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/\((.*?)\)/)[0]}}</span>
      </div>
      <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('skin_color')">
        {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/\((.*?)\)/)[0]}}</span>
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element" v-if="isNotEqual('blood_type')">
        {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.donor.blood_type) }}
      </div>
      <div class="element" v-if="isNotEqual('blood_rh_factor')">
        {{ $t('phenotype.blood_rh_factor.' + getContext + '.' + compareTable.donor.blood_rh_factor) }}
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element" v-if="isNotEqual('eye_color')">{{$t('phenotype.eye_color.' + getContext + '.' + compareTable.donor.eye_color)}}</div>
      <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('hair_color')">
        {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/\((.*?)\)/)[0]}}</span> 
      </div>
      <div class="element" v-if="isNotEqual('hair_structure')">{{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.donor.hair_structure)}}</div>
      <div class="element" v-if="isNotEqual('height')">{{compareTable.donor.height}} {{$t('cm')}}</div>
      <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('silhouette')">
        {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/\((.*?)\)/)[0]}}</span> 
      </div>

      <div class="reservation-button-wrapper" v-if="!oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')">
        <v-dialog
          v-if="action === 'reserve'"
          v-model="dialogOpen"
          :fullscreen="$vuetify.display.mobile"
        >
          <template v-slot:activator="{ attrs }">
            <v-btn plain elevation="0"
              v-bind="attrs"
              @click="showReservationDialog"
              class="mt-4 mb-md-0 mb-8"
              color="primary"
              height="40"
              :width="'100%'"
              rounded
            > 
              {{$t('reservation.reserve_btn')}}
            </v-btn>
          </template>
          <div class="close" :class="{'mobile': $vuetify.display.mobile}" @click="dialogOpen = false">
            <v-icon color="primary">mdi-close</v-icon>
          </div>
          <add-to-cart-component
            :donor-details="donor_phenotype"
            :maxTrueReservationCount="maxTrueReservationCount"
            :dialog="true"
            :age="getDonorAge"
            @close="hideReservationDialog"
          ></add-to-cart-component>
        </v-dialog>
        <v-btn 
          v-if="action === 'accept'"
          plain elevation="0"
          v-bind="attrs"
          @click="acceptDonorChoice"
          class="mt-4 mb-4"
          color="primary"
          height="40"
          :disabled="acceptDonorBtnDisabled"
          :width="'208px'"
          rounded
        > 
          {{$t('confirmation.accept_btn')}}
        </v-btn>
      </div>
    </div>

    <div class="compare-data pa-4 div3" v-if="Object.keys(compareTable.own).length">
      <div class="compare-header">
        <span class="recipient">{{getMyGender()}}</span>
      </div>

      <div class="description-header d-flex align-center"></div>
      <div class="element d-flex align-center high" v-if="isNotEqual('race')">
        <img :src="checkTrait('race','own')" class="mr-3"/>
        <div>
        {{$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>
      <div class="element d-flex align-center high" v-if="isNotEqual('skin_color')">
        <img :src="checkTrait('skin_color','own')" class="mr-3"/>
        <div>
        {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element d-flex align-center" v-if="isNotEqual('blood_type')">
        <img :src="checkTrait('blood_type','own')" class="mr-3"/>
        {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.own.bloodType) }}
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('blood_rh_factor')">
        <img :src="checkTrait('blood_rh_factor','own')" class="mr-3"/>
        {{ $t('phenotype.blood_rh_factor.' + getContext + '.' + compareTable.own.bloodRhFactor) }}
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element d-flex align-center" v-if="isNotEqual('eye_color')">
        <img :src="checkTrait('eye_color','own')" class="mr-3"/>
        {{$t('phenotype.eye_color.' + getContext + '.' + compareTable.own.eyeColor)}}</div>
      <div class="element d-flex align-center high" v-if="isNotEqual('hair_color')">
        <img :src="checkTrait('hair_color','own')" class="mr-3"/>
        <div>
        {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/([^\()]+)/)[0] }}<br/>
          <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/\((.*?)\)/)[0]}}</span>
        </div> 
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('hair_structure')">
        <img :src="checkTrait('hair_structure','own')" class="mr-3"/>
        {{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.own.hairShape)}}
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('height')">
        <img :src="checkTrait('height','own')" class="mr-3"/>
        {{compareTable.own.height}} {{$t('cm')}}
      </div>
      <div class="element d-flex align-center high" v-if="isNotEqual('silhouette')">
        <img :src="checkTrait('silhouette','own')" class="mr-3"/>
        <div>
        {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/([^\()]+)/)[0] }}<br/>
          <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>

    </div>
    <div class="no-phenotype compare-data pa-4 div3" v-else>
      <div v-if="!hasPhenotypeMode('own')"
      no-gutters justify="center" class="blocked">

      <div class="compare-header">{{getMyGender()}}</div>
        <div 
          class="no-phenotype text-center mt-5 d-flex flex-column justify-center align-center"
          v-if="oidc_user?.roles.includes('ROLE_PATIENT')">
          <div class="mb-4">
            <v-icon
              class="mt-n1 mr-1"
              size="12"
              icon="padlock primary"
            ></v-icon>
              {{$t('recipient.to_use_this_feature_text')}}
          </div>
          <v-btn class="mt-n1" color="primary" variant="outlined" height="40" rounded @click="goToPhenotype">
            {{$t('recipient.add_phenotype_btn')}}
          </v-btn>
        </div>
      </div>
    </div>

    <div class="compare-data pa-4 div4" v-if="Object.keys(compareTable.partner).length">
      <div class="compare-header">
        <span class="recipient">{{getPartnerGender()}}</span>
      </div>

      <div class="description-header d-flex align-center"></div>
      <div class="element d-flex align-center high" v-if="isNotEqual('race')">
        <img :src="checkTrait('race','partner')" class="mr-3"/>
        <div>
        {{$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>
      <div class="element d-flex align-center high" v-if="isNotEqual('skin_color')">
        <img :src="checkTrait('skin_color','partner')" class="mr-3"/>
        <div>
        {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/([^\()]+)/)[0] }}<br/>
        <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element d-flex align-center" v-if="isNotEqual('blood_type')">
        <img :src="checkTrait('blood_type','partner')" class="mr-3"/>
        {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.partner.bloodType) }}
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('blood_rh_factor')">
        <img :src="checkTrait('blood_rh_factor','partner')" class="mr-3"/>
        {{ $t('phenotype.blood_rh_factor.' + getContext + '.' + compareTable.partner.bloodRhFactor) }}
      </div>

      <div class="description-header d-flex align-center mt-16"></div>
      <div class="element d-flex align-center" v-if="isNotEqual('eye_color')">
        <img :src="checkTrait('eye_color','partner')" class="mr-3"/>
        {{$t('phenotype.eye_color.' + getContext + '.' + compareTable.partner.eyeColor)}}</div>
      <div class="element d-flex align-center high" v-if="isNotEqual('hair_color')">
        <img :src="checkTrait('hair_color','partner')" class="mr-3"/>
        <div>
        {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/([^\()]+)/)[0] }}<br/>
          <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/\((.*?)\)/)[0]}}</span>
        </div> 
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('hair_structure')">
        <img :src="checkTrait('hair_structure','partner')" class="mr-3"/>
        {{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.partner.hairShape)}}
      </div>
      <div class="element d-flex align-center" v-if="isNotEqual('height')">
        <img :src="checkTrait('height','partner')" class="mr-3"/>
        {{compareTable.partner.height}} {{$t('cm')}}
      </div>
      <div class="element d-flex align-center high" v-if="isNotEqual('silhouette')">
        <img :src="checkTrait('silhouette','partner')" class="mr-3"/>
        <div>
        {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/([^\()]+)/)[0] }}<br/>
          <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/\((.*?)\)/)[0]}}</span>
        </div> 
      </div>

    </div>
    <div class="no-phenotype compare-data pa-4 div4" v-else>
      <div v-if="!hasPhenotypeMode('partner')"
      no-gutters justify="center" class="blocked">
        <div class="compare-header">
          <span class="recipient empty">{{getPartnerGender()}}</span>
        </div>
        <div 
          class="no-phenotype text-center mt-5 d-flex flex-column justify-center align-center"
          v-if="oidc_user?.roles.includes('ROLE_PATIENT')">
          <div class="mb-4">
            <v-icon
              class="mt-n1 mr-1"
              size="12"
              icon="padlock primary"
            ></v-icon>
              {{$t('recipient.to_use_this_feature_text')}}
          </div>
          <v-btn class="mt-n1" color="primary" variant="outlined" height="40" rounded @click="goToPhenotype">
            {{$t('recipient.add_phenotype_btn')}}
          </v-btn>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="compare-wrapper-mobile pa-4">
    <swiper
      :slides-per-view="1.5"
      :space-between="50"
      :slides-offset-after="200"
      :slide-active-class="'slide-active'"
      :resistance="true"
      :resistance-ratio="0"
    >
      <swiper-slide>
        <div class="compare-data legend pa-4 pl-0 div1">
          <div class="compare-header checkbox-wrapper d-flex align-center">
            <label class="container input-label text-left pr-2 mb-6 mb-md-0">
              {{$t('donor.compare.show_only_differences_label')}}
              <input type="checkbox" v-model="differencesChecked">
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="description-header d-flex align-center">
            <img :src="group_icon" class="mr-2"/><span>{{$t('donor.phenotype.origin_label')}}</span>
          </div>
          <div class="description" v-if="isNotEqual('race')">{{$t('donor.phenotype.race')}}</div>
          <div class="description" v-if="isNotEqual('skin_color')">{{$t('donor.phenotype.skin_color')}}</div>

          <div class="description-header d-flex align-center mt-5">
            <img :src="blood_icon" class="mr-2"/><span>{{$t('donor.phenotype.blood_label')}}</span>
          </div>
          <div class="description" v-if="isNotEqual('blood_type')">{{$t('donor.phenotype.blood_type')}}</div>
          <div class="description" v-if="isNotEqual('blood_rh_factor')">{{$t('donor.phenotype.blood_fh_factor')}}</div>

          <div class="description-header d-flex align-center mt-5">
            <img :src="eye_icon" class="mr-2"/><span>{{$t('donor.phenotype.physical_features_label')}}</span>
          </div>
          <div class="description" v-if="isNotEqual('eye_color')">{{$t('donor.phenotype.eye_color')}}</div>
          <div class="description high" v-if="isNotEqual('hair_color')">{{$t('donor.phenotype.hair_color')}}</div>
          <div class="description" v-if="isNotEqual('hair_structure')">{{$t('donor.phenotype.hair_shape')}}</div>
          <div class="description" v-if="isNotEqual('height')">{{$t('donor.phenotype.height')}}</div>
          <div class="description high" v-if="isNotEqual('silhouette')">{{$t('donor.phenotype.body_type')}}</div>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="compare-data donor pa-4 div2" v-if="Object.keys(compareTable.donor).length">
          <div class="compare-header">
            <div class="photo-wrapper d-flex flex-column justify-start w-100">
              <img :src="placeholder" class="photo mb-2" />
              <span>{{getDonorGender}}</span>
              <div class="id-wrapper d-flex align-items-center mt-3" v-if="donor_nickname">
                <span class="id px-3">{{donor_nickname}}</span>
                <v-icon v-if="oidc_user?.roles.includes('ROLE_PATIENT')"
                  @click="toggleFavourite" :icon="isFavourite ? 'mdi-heart' : 'mdi-heart-outline'" 
                  :size="24" class="icon ml-2" :color="isFavourite ? 'primary' : 'primary200'"></v-icon>
              </div>
            </div>
            <div class="id-wrapper d-flex align-items-center" v-if="oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')">
              {{$t('donor.compare.profile_id_label')}} <span class="id px-3 ml-1">{{donor_id}}</span>
            </div>
          </div>

          <div class="description-header d-flex align-center"></div>
          <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('race')">
            {{$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.donor.race).match(/\((.*?)\)/)[0]}}</span>
          </div>
          <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('skin_color')">
            {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.donor.skin_color).match(/\((.*?)\)/)[0]}}</span>
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element" v-if="isNotEqual('blood_type')">
            {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.donor.blood_type) }}
          </div>
          <div class="element" v-if="isNotEqual('blood_rh_factor')">
            {{compareTable.donor.blood_rh_factor}}
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element" v-if="isNotEqual('eye_color')">{{$t('phenotype.eye_color.' + getContext + '.' + compareTable.donor.eye_color)}}</div>
          <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('hair_color')">
            {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.donor.hair_color).match(/\((.*?)\)/)[0]}}</span> 
          </div>
          <div class="element" v-if="isNotEqual('hair_structure')">{{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.donor.hair_structure)}}</div>
          <div class="element" v-if="isNotEqual('height')">{{compareTable.donor.height}} {{$t('cm')}}</div>
          <div class="element d-flex flex-column justify-center high" v-if="isNotEqual('silhouette')">
            {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.donor.silhouette).match(/\((.*?)\)/)[0]}}</span> 
          </div>

          <div class="reservation-button-wrapper" v-if="!oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')">
            <v-dialog
              v-if="action == 'reserve'"
              v-model="dialogOpen"
              :fullscreen="$vuetify.display.mobile"
            >
              <template v-slot:activator="{ attrs }">
                <v-btn plain elevation="0"
                  v-bind="attrs"
                  @click="showReservationDialog"
                  class="mt-4 mb-4"
                  color="primary"
                  height="40"
                  :width="'208px'"
                  rounded
                > 
                  {{$t('reservation.reserve_btn')}}
                </v-btn>
              </template>
              <div class="close" :class="{'mobile': $vuetify.display.mobile}" @click="dialogOpen = false">
                <v-icon color="primary">mdi-close</v-icon>
              </div>
              <add-to-cart-component
                :donor-details="donor_phenotype"
                :maxTrueReservationCount="maxTrueReservationCount"
                :dialog="true"
                :age="getDonorAge"
                @close="hideReservationDialog"
              ></add-to-cart-component>
            </v-dialog>
            <v-btn 
              v-if="action == 'accept'"
              plain elevation="0"
              v-bind="attrs"
              @click="acceptDonorChoice"
              class="mt-4 mb-4"
              color="primary"
              height="40"
              :width="'208px'"
              rounded
            > 
              {{$t('confirmation.accept_btn')}}
            </v-btn>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="compare-data pa-4 div3" v-if="Object.keys(compareTable.own).length">
          <div class="compare-header">
            <span class="recipient">{{getMyGender()}}</span>
          </div>

          <div class="description-header d-flex align-center"></div>
          <div class="element d-flex align-center high" v-if="isNotEqual('race')">
            <img :src="checkTrait('race','own')" class="mr-3"/>
            <div>
            {{$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.own.race.key).match(/\((.*?)\)/)[0]}}</span>
            </div>
          </div>
          <div class="element d-flex align-center high" v-if="isNotEqual('skin_color')">
            <img :src="checkTrait('skin_color','own')" class="mr-3"/>
            <div>
            {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.own.skinColor.key).match(/\((.*?)\)/)[0]}}</span>
            </div>
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element d-flex align-center" v-if="isNotEqual('blood_type')">
            <img :src="checkTrait('blood_type','own')" class="mr-3"/>
            {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.own.bloodType) }}
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('blood_rh_factor')">
            <img :src="checkTrait('blood_rh_factor','own')" class="mr-3"/>
            {{ $t('phenotype.blood_rh_factor.' + getContext + '.' + compareTable.own.bloodRhFactor) }}
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element d-flex align-center" v-if="isNotEqual('eye_color')">
            <img :src="checkTrait('eye_color','own')" class="mr-3"/>
            {{$t('phenotype.eye_color.' + getContext + '.' + compareTable.own.eyeColor)}}</div>
          <div class="element d-flex align-center high" v-if="isNotEqual('hair_color')">
            <img :src="checkTrait('hair_color','own')" class="mr-3"/>
            <div>
            {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/([^\()]+)/)[0] }}<br/>
              <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.own.hairColor).match(/\((.*?)\)/)[0]}}</span>
            </div> 
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('hair_structure')">
            <img :src="checkTrait('hair_structure','own')" class="mr-3"/>
            {{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.own.hairShape)}}
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('height')">
            <img :src="checkTrait('height','own')" class="mr-3"/>
            {{compareTable.own.height}} {{$t('cm')}}
          </div>
          <div class="element d-flex align-center high" v-if="isNotEqual('silhouette')">
            <img :src="checkTrait('silhouette','own')" class="mr-3"/>
            <div>
            {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/([^\()]+)/)[0] }}<br/>
              <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.own.bodyType).match(/\((.*?)\)/)[0]}}</span>
            </div> 
          </div>

        </div>
        <div class="compare-data pa-4 div3" v-else>
          <div v-if="!hasPhenotypeMode('own')"
          no-gutters justify="center" class="blocked">

          <div class="compare-header">{{getMyGender()}}</div>
            <div 
              class="text-center mt-5 d-flex flex-column justify-center align-center"
              v-if="oidc_user?.roles.includes('ROLE_PATIENT')">
              <div class="mb-4">
                <v-icon
                  class="mt-n1 mr-1"
                  size="12"
                  icon="padlock primary"
                ></v-icon>
                  {{$t('recipient.to_use_this_feature_text')}}
              </div>
              <v-btn class="mt-n1" color="primary" variant="outlined" height="40" rounded @click="goToPhenotype">
                {{$t('recipient.add_phenotype_btn')}}
              </v-btn>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="compare-data pa-4 div4" v-if="Object.keys(compareTable.partner).length">
          <div class="compare-header">
            <span class="recipient">{{getPartnerGender()}}</span>
          </div>

          <div class="description-header d-flex align-center"></div>
          <div class="element d-flex align-center high" v-if="isNotEqual('race')">
            <img :src="checkTrait('race','partner')" class="mr-3"/>
            <div>
            {{$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/\((.*?)\)/)">{{$t('phenotype.race.' + getContext + '.' + compareTable.partner.race.key).match(/\((.*?)\)/)[0]}}</span>
            </div>
          </div>
          <div class="element d-flex align-center high" v-if="isNotEqual('skin_color')">
            <img :src="checkTrait('skin_color','partner')" class="mr-3"/>
            <div>
            {{$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/([^\()]+)/)[0] }}<br/>
            <span class="sub-entry" v-if="$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + getContext + '.' + compareTable.partner.skinColor.key).match(/\((.*?)\)/)[0]}}</span>
            </div>
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element d-flex align-center" v-if="isNotEqual('blood_type')">
            <img :src="checkTrait('blood_type','partner')" class="mr-3"/>
            {{ $t('phenotype.blood_type.' + getContext + '.' + compareTable.partner.bloodType) }}
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('blood_rh_factor')">
            <img :src="checkTrait('blood_rh_factor','partner')" class="mr-3"/>
            {{ $t('phenotype.blood_rh_factor.' + getContext + '.' + compareTable.partner.bloodRhFactor) }}
          </div>

          <div class="description-header d-flex align-center mt-5"></div>
          <div class="element d-flex align-center" v-if="isNotEqual('eye_color')">
            <img :src="checkTrait('eye_color','partner')" class="mr-3"/>
            {{$t('phenotype.eye_color.' + getContext + '.' + compareTable.partner.eyeColor)}}</div>
          <div class="element d-flex align-center high" v-if="isNotEqual('hair_color')">
            <img :src="checkTrait('hair_color','partner')" class="mr-3"/>
            <div>
            {{$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/([^\()]+)/)[0] }}<br/>
              <span class="sub-entry" v-if="$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + getContext + '.' + compareTable.partner.hairColor).match(/\((.*?)\)/)[0]}}</span>
            </div> 
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('hair_structure')">
            <img :src="checkTrait('hair_structure','partner')" class="mr-3"/>
            {{$t('phenotype.hair_structure.' + getContext + '.' + compareTable.partner.hairShape)}}
          </div>
          <div class="element d-flex align-center" v-if="isNotEqual('height')">
            <img :src="checkTrait('height','partner')" class="mr-3"/>
            {{compareTable.partner.height}} {{$t('cm')}}
          </div>
          <div class="element d-flex align-center high" v-if="isNotEqual('silhouette')">
            <img :src="checkTrait('silhouette','partner')" class="mr-3"/>
            <div>
            {{$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/([^\()]+)/)[0] }}<br/>
              <span class="sub-entry" v-if="$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/\((.*?)\)/)">{{$t('phenotype.silhouette.' + getContext + '.' + compareTable.partner.bodyType).match(/\((.*?)\)/)[0]}}</span>
            </div> 
          </div>

        </div>
        <div class="compare-data pa-4 div4" v-else>
          <div v-if="!hasPhenotypeMode('partner')"
          no-gutters justify="center" class="blocked">
            <div class="compare-header">
              <span class="recipient empty">{{getPartnerGender()}}</span>
            </div>
            <div 
              class="text-center mt-5 d-flex flex-column justify-center align-center" 
              v-if="oidc_user?.roles.includes('ROLE_PATIENT')">
              <div class="mb-4">
                <v-icon
                  class="mt-n1 mr-1"
                  size="12"
                  icon="padlock primary"
                ></v-icon>
                  {{$t('recipient.to_use_this_feature_text')}}
              </div>
              <v-btn class="mt-n1" color="primary" variant="outlined" height="40" rounded @click="goToPhenotype">
                {{$t('recipient.add_phenotype_btn')}}
              </v-btn>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapGetters, useStore } from 'vuex';
import router from "@/router";
import axios from "axios";
import { computed } from 'vue';
import AddToCartComponent from '@/components/AddToCartComponent.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

export default {
    name: "compare-to-donor-data-component",
    data: () => {
      return {
        differencesChecked: false,
        dialogOpen: false,
        acceptDonorBtnDisabled: false,
      }
    },
    components: {
      AddToCartComponent,
      Swiper,
      SwiperSlide
    },
    props: {
      compare_fetched_table: {
        type: Object,
        required: true
      },
      donor_phenotype: {
        type: Object,
        required: true
      },
      donor_id: {
        type: String,
        required: false
      },
      donor_nickname: {
        type: String,
        required: true
      },
      donor_product_key: {
        type: String,
        required: true
      },
      donor_material_type: {
        type: String,
        required: true
      },
      oidc_user: {
        type: Object,
        required: true
      },
      user_id: {
        type: Number,
        required: false
      },
      action: {
        type: String,
        required: false,
        default: 'reserve'
      }
    },
    computed: {
      ...mapGetters('phenotypeModule',['getPhenotype']),
      ...mapGetters('favouritesModule', ['getFavourites']),
      maxTrueReservationCount() {
        return this.donor_phenotype.max_true_reservation_count[0];
      },
      getDonorAge() {
        return this.donor_phenotype.age ? this.donor_phenotype.age[0] : 0;
      },
      getContext() {
        return this.donor_material_type
      },
      getDonorGender() {
        return this.$t(`donor.${this.donor_material_type}.nom`);
      },
      placeholder() {
        if(this.donor_material_type == "mtCell")
          return require('../assets/img/placeholder_female.svg')
        else
          return require('../assets/img/placeholder_male.svg')
      },
      isFavourite() {
        return this.getFavourites.find(e => e.donor_product_key == this.donor_product_key && e.material_type == this.donor_material_type);
      }
    },
    setup() {
      const trait_ok = require('../assets/icons/shield-green.svg');
      const trait_nok = require('../assets/icons/shield-orange.svg');
      const store = useStore();

      const eye_icon = computed({
        get: () => { return require('../assets/icons/eye.svg');}
      })
      const blood_icon = computed({
        get: () => { return require('../assets/icons/blood.svg');}
      })
      const group_icon = computed({
        get: () => { return require('../assets/icons/group.svg');}
      })
      return {
        trait_nok,
        trait_ok,
        eye_icon,
        blood_icon,
        group_icon,
        store,
        hasPhenotypeMode: (mode) => store.getters["phenotypeModule/hasPhenotypeMode"](mode),
      }
    },
    created() {
      if (Object.keys(this.compare_fetched_table).length) {
        this.compareTable = this.compare_fetched_table
      } else {
        this.createCompareTable()
      }
    },
    emits: ['close-compare-dialog'],
    methods: {
      acceptDonorChoice() {
        this.acceptDonorBtnDisabled = true
        axios
          .post(`/api/donor/phenotype_acceptance`, {
            "donor_phenotype": {
              "race": "WHITE_RACE",
              "height": this.donor_phenotype.phenotype.height,
              "weight": this.donor_phenotype.phenotype.weight,
              "gender": this.donor_material_type == "mtCell" ? "FEMALE" : "MALE",
              "bodyType": this.donor_phenotype.phenotype.silhouette,
              "eyeColor": this.donor_phenotype.phenotype.eye_color,
              "ethnicity": this.donor_phenotype.phenotype.ethnicity,
              "hairColor": this.donor_phenotype.phenotype.hair_color,
              "hairShape": this.donor_phenotype.phenotype.hair_structure,
              "skinColor": this.donor_phenotype.phenotype.skin_color,
              "bloodType": this.donor_phenotype.phenotype.blood_type,
              "bloodRhFactor": this.donor_phenotype.phenotype.blood_rh_factor
            },
            "product_key": this.donor_product_key
          })
          .then((response) => {
            let acceptanceId = response.data.acceptance_id
            this.$store.dispatch('cartModule/setItemAcceptanceId', {
              id: this.donor_product_key, 
              acceptanceId: acceptanceId 
            }).then(() => {
              if (!this.$store.getters['cartModule/getEmptyAcceptanceIdItemsLength']) {
                this.goToReservation()
              }
            }).finally(() => {
              window.scrollTo({ top: 0, behavior: 'smooth'})
            })
          })
          .catch(err => {
            console.error(err);
          })
      },
      goToReservation() {
        this.$router.push({name: 'reservationView'})
        window.scrollTo({ top: 0, behavior: 'smooth'})
      },
      goToPhenotype() {
        const routeName = this.$route.name
        const routePath = this.$route.path
        this.$emit('close-compare-dialog', true);
        this.dialogOpen = false;
        this.$store.dispatch('phenotypeModule/setReturnRoute', {name: routeName, path: routePath, reservation: false}).then(() => {
          router.push({ name: 'dashboardView', query: {selected: "phenotype"} })
        })
      },
      createCompareTable() {
        this.compareTable = {
          donor: this.donor_phenotype.phenotype,
          own: this.getPhenotype.own || {},
          partner: this.getPhenotype.partner || {}
        }
      },
      getMyGender() {
        if(this.compareTable.own) {
          return this.compareTable.own.gender == 'FEMALE' ? this.$t(`recipient.FEMALE.recipient_nom`) : this.$t(`recipient.MALE.recipient_nom`);
        } else {
          return this.$t(`empty_value`);
        }
      },
      getPartnerGender() {
        if(this.compareTable.partner) {
          return this.compareTable.partner.gender == 'FEMALE' ? this.$t(`recipient.FEMALE.partner_nom`) : this.$t(`recipient.MALE.partner_nom`);
        } else {
          return this.$t(`empty_value`);
        }
      },
      hideReservationDialog() {
        this.dialogOpen = false;
        this.$emit('close-compare-dialog', true);
      },
      showReservationDialog() {
        this.dialogOpen = true;
      },
      checkTrait(trait,owner) {
        switch(trait) {
          case 'eye_color':
            return this.compareTable.donor.eye_color == this.compareTable[owner].eyeColor ? this.trait_ok : this.trait_nok;
          case 'hair_color':
            return this.compareTable.donor.hair_color == this.compareTable[owner].hairColor ? this.trait_ok : this.trait_nok;
          case 'hair_structure':
            return this.compareTable.donor.hair_structure == this.compareTable[owner].hairShape ? this.trait_ok : this.trait_nok;
          case 'height':
            return this.compareTable.donor.height == this.compareTable[owner].height ? this.trait_ok : this.trait_nok;
          case 'silhouette':
            return this.compareTable.donor.silhouette == this.compareTable[owner].bodyType ? this.trait_ok : this.trait_nok;

          case 'blood_type':
            return this.compareTable.donor.blood_type == this.compareTable[owner].bloodType ? this.trait_ok : this.trait_nok;
          case 'blood_rh_factor':
            return this.compareTable.donor.blood_rh_factor == this.compareTable[owner].bloodRhFactor ? this.trait_ok : this.trait_nok;

          case 'skin_color':
            return this.compareTable.donor.skin_color == this.compareTable[owner].skinColor?.key ? this.trait_ok : this.trait_nok;
          case 'race':
            return this.compareTable.donor.race == this.compareTable[owner].race?.key ? this.trait_ok : this.trait_nok;

          default:
            return this.trait_nok;
        }
      },
      isNotEqual(trait) {
        let ownResult = Object.keys(this.compareTable).length && this.checkTrait(trait,'own') == this.trait_nok;
        let partnerResult = Object.keys(this.compareTable).length && this.checkTrait(trait,'partner') == this.trait_nok;
        if(this.differencesChecked) {
          return ownResult && partnerResult;
        } else {
          return true;
        }
      },
      toggleFavourite(){
        if (this.isFavourite) {
          this.store.dispatch('favouritesModule/removeFavourite', {
            donor_product_key: this.donor_product_key,
            material_type: this.donor_material_type
          }).then(() => {
            this.$gtag.event('donor', {
              'donor_product_key': this.donor_product_key,
              'donor_material_type': this.donor_material_type,
              'donor_event_value': 'remove from favourites'
            })
          })
        } else {
          this.store.dispatch('favouritesModule/addFavourite', {
            donor_product_key: this.donor_product_key,
            material_type: this.donor_material_type
          }).then(() => {
            this.$gtag.event('donor', {
              'donor_product_key': this.donor_product_key,
              'donor_material_type': this.donor_material_type,
              'donor_event_value': 'add to favourites'
            })
          })
        }
      }
    }
}
</script>

<style lang="scss" scoped>

.reservation-button-wrapper {
  margin: -16px;
  margin-top: 24px;
  background: white;
}
.parent {
  position: relative;
}
.compare-data {
  .compare-header {
    height: 248px;
    @include nsb-gentium-bold;
    font-size: 23px;
    line-height: 26px;
    &::first-letter {
      text-transform: capitalize;
    }
    .photo-wrapper {
      position: relative;
      padding: 0px;
      .photo {
          max-width: 128px;
      }
    }
    .recipient {
      text-transform: capitalize;
      position: absolute;
      top: 152px;
      &.empty {
        top: 136px;
      }
    }
  }
  min-width: 208px;
  width: 25%;
  .description-header {
    @include nsb-font-container-medium;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 21px;
    height: 40px;
    img {
      height: 24px;
      width: 24px;
    }
  }
}
.donor {
  background-color: $ds-secondary-300;
  border-radius: 4px;
}
.id-wrapper {
  @include nsb-font-container-medium;
  font-size: 14px;
  line-height: 21px;
  .id {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;
    border-radius: 12px;
    background-color: $ds-primary-9;
    margin-top: 2px;
    margin-bottom: 2px;
  }
  .icon {
    cursor: pointer;
  }
}
.description,
.element {
  @include nsb-font-container;
  font-size: 14px;
  line-height: 21px;
  height: 40px;
  line-height: 40px;
  display: block;
}
.description.high {
  height: 40px;
}
.element.high {
  height: 40px;
  line-height: 20px;
}

.sub-entry {
  font-size: 10px;
  color: $ds-primary;
}

.blocked {
  position: absolute;
  height: 100%;
  z-index: 2;

  &.single {
    position: relative;
    max-width: 280px;
    min-width: 126px;
    z-index: 1;
  }

  .v-btn {
    background: $ds-white;
  }
}

.no-phenotype {
  background-color: $ds-secondary-9;
  @include nsb-font-container;
  width: 100%;
}
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  user-select: none;
  @include nsb-font-container;
  font-size: 14px;
  line-height: 21px;
  max-width: 204px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #00205B;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  position: absolute;
  top: 50%;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.close{
  cursor: pointer;
  position: fixed;
  top: 22px;
  right: 30px;
  z-index: 10;
  &.mobile {
    right: 30px;
  }
}
</style>